import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useScript } from '../../hooks/useScript.hook';
import { ClientOnlyContent } from '../../components/atoms/ClientOnlyContent';
import { MainLayout } from '../../components/layouts/MainLayout';
import { Spacer } from '../../uikit/misc/Spacer';
import { Container } from '../../uikit/grid';
import { Logger } from '../../utils/Logger';
var FCLeadFormRaw = function () {
    var isLoaded = useScript('https://widgets.fincrm.de/js/leadform.js').isLoaded;
    var widgetRef = useRef(null);
    useEffect(function () {
        var effect = function () {
            if (!isLoaded) {
                return;
            }
            // Any due to 
            var widget = widgetRef.current;
            if (!widget) {
                Logger.log('Widget not found');
                return;
            }
            ;
            Logger.log('Widget found');
            widget.addEventListener('leadSubmitted', function (event) {
                var _a, _b;
                /* @es */
                Logger.log('leadSubmitted', event);
                var leadSubmittedEvent = event;
                var purpose = (_b = (_a = leadSubmittedEvent.detail) === null || _a === void 0 ? void 0 : _a.purpose) === null || _b === void 0 ? void 0 : _b.type;
                // trigger external systems (parent page / GTM)
                window.parent.postMessage({
                    type: 'fincrm_leadSubmitted',
                    purpose: purpose,
                    ts: Date.now()
                }, '*');
            });
        };
        effect();
    }, [isLoaded]);
    return (React.createElement(MainLayout, null,
        React.createElement(Container, { disableGutters: function (theme) { return theme.breakpoints.up('md'); } },
            React.createElement(Spacer, { size: 2 }),
            React.createElement(ClientOnlyContent, null,
                React.createElement("fc-leadform", { ref: widgetRef, "api-key": "eyJiYXNlX3VybCI6Imh0dHBzOi8vZmluYW56Y2hlY2suZmluY3JtLmRlIn0=", "show-avatars": "false" })),
            React.createElement(Spacer, { size: 2 }))));
};
export var FCLeadFormPage = connect()(FCLeadFormRaw);
